import React, { useState, useEffect } from "react"
import { Upload, Form, Input, message, Modal } from "antd"
import {
  UploadOutlined,
  InfoCircleOutlined,
  EyeOutlined,
} from "@ant-design/icons"
import "../../styles/Components/uploadinputfile.css"
import { translations } from "../../utils/Translation/staticTranslation"

const UploadInput = ({
  disabled,
  maxSizeMB = 1,
  formclass,
  suffix,
  label,
  placeholder,
  onFileChange,
  className,
  name,
  rules,
  form,
  ...rest
}) => {
  const [fileList, setFileList] = useState(null)
  const [previewVisible, setPreviewVisible] = useState(false)
  const [previewImage, setPreviewImage] = useState("")
  const [previewTitle, setPreviewTitle] = useState("")

  const lang = localStorage.getItem("language") || "ar"
  const common_error_msg = translations[lang]?.common_error_msg
  const upload_file_comp = translations[lang]?.upload_file_comp

  const handlePreview = async () => {
    if (!fileList) return

    // Create a preview URL for the file
    const previewUrl = URL.createObjectURL(fileList)
    setPreviewImage(previewUrl)
    setPreviewTitle(fileList.name || "Preview")
    setPreviewVisible(true)
  }

  const handleCancel = () => {
    setPreviewVisible(false)
  }

  const uploadProps = {
    accept: ".png,.jpg,.jpeg",
    beforeUpload: (file) => {
      const isValidType = ["image/png", "image/jpeg", "image/jpg"].includes(
        file.type
      )
      const isValidSize = file.size / 1024 / 1024 < maxSizeMB

      if (!isValidType) {
        message.error(common_error_msg?.only_png_jpeg)
        return Upload.LIST_IGNORE
      }
      if (!isValidSize) {
        message.error(`${upload_file_comp?.file_size_error} ${maxSizeMB}MB.`)
        return Upload.LIST_IGNORE
      }

      // Save the actual file in local state
      setFileList(file)

      return false // Prevent auto-upload
    },
    showUploadList: false, // Hide file list UI
  }

  return (
    <>
      <Form.Item
        label={label}
        className={formclass}
        name={name}
        rules={rules}
        {...rest}
        getValueFromEvent={(e) => e?.fileList?.[0]?.originFileObj || null}
      >
        <Upload
          style={{ width: "100%" }}
          {...uploadProps}
          className="upload-input-file"
          listType="picture"
          maxCount={1}
        >
          <Input
            disabled={disabled}
            value={fileList ? fileList.name : ""}
            readOnly
            className={`${className} ${fileList ? "has-file" : ""}`}
            placeholder={placeholder}
            suffix={
              <>
                {fileList && (
                  <EyeOutlined
                    onClick={(e) => {
                      e.stopPropagation()
                      handlePreview()
                    }}
                    style={{ marginRight: 8, cursor: "pointer" }}
                  />
                )}
                {suffix}
              </>
            }
          />
        </Upload>
      </Form.Item>
      {/* Preview Modal */}
      <Modal
        open={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img alt={previewTitle} style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </>
  )
}

export default UploadInput
